import React from 'react';

import Input from '../../Input';
import { useTranslation } from 'react-i18next';
import { required, validYear } from '../../../services/validators.service';

export default function Year(props) {
    const { t } = useTranslation();

    const validators = [required(t('empty_mandatory_error')), validYear(t('number_validation_txt'))];

    return <Input validators={validators} {...props}></Input>;
}
